<header>
  <h1>Reporting</h1>
</header>
<section aria-labelledby="favorites-report-title">
  <mat-card>
    <mat-card-header>
      <mat-card-title id="favorites-report-title"
        >Favorites Report</mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <p>
        Most favourited items, highest first. Download the full report as a CSV.
      </p>
      <div class="report-actions">
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="downloadCSV()"
          [disabled]="downloading"
        >
          <mat-icon>download</mat-icon>
          {{ downloading ? 'Downloading CSV…' : 'Download CSV' }}
        </button>
        @if (downloading) {
        <span role="status">{{ downloadedItems }} items collected</span>
        <button type="button" mat-button (click)="cancelDownload()">
          Cancel download
        </button>
        }
        <button
          type="button"
          mat-button
          (click)="loadPage(0)"
          [disabled]="loading"
        >
          <mat-icon>refresh</mat-icon> Refresh
        </button>
      </div>

      <div [attr.aria-busy]="loading" class="report-results">
        @if (loading) {
        <p role="status">Loading most favourited items…</p>
        } @else if (loadError) {
        <p role="alert">Unable to load the report.</p>
        <button type="button" mat-button (click)="loadPage(pageIndex)">
          Retry
        </button>
        } @else if (items.length === 0) {
        <p>
          {{ totalItems === 0 ? 'No items have been favourited yet.' : 'No items
          on this page. Refresh to see the latest report.' }}
        </p>
        } @else {
        <table>
          <caption class="visually-hidden">
            Most favourited items
          </caption>
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Item</th>
              <th scope="col" class="count">Favourites</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.listingId; let index = $index) {
            <tr>
              <td class="rank">{{ pageIndex * pageSize + index + 1 }}</td>
              <td>
                {{ item.name }}<span class="listing-id"
                  >Listing #{{ item.listingId }}</span
                >
              </td>
              <td class="count">{{ item.favouriteCount | number }}</td>
            </tr>
            }
          </tbody>
        </table>
        }
      </div>
      <mat-paginator
        aria-label="Most favourited items pages"
        [length]="totalItems"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 100]"
        [disabled]="loading"
        [showFirstLastButtons]="true"
        (page)="loadPage($event.pageIndex, $event.pageSize)"
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</section>
